import moment from 'moment';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';
import { apiConstants } from '../_constants';
import { examService } from '../_services/exam.service';
import { secondsToHHMM, trimString } from '../_services/misc.service';

export const EdraaQuizItem = ({ quizItem }) => {
  const navigate = useNavigate();

  useEffect(() => {
    checkRetest(quizItem);
  }, [quizItem]);

  const checkRetest = (item) => {
    const questionCount = parseInt(item?.mocktestcount);
    const answerCount = parseInt(item?.answercount);
    if (answerCount > 0 && answerCount >= questionCount) {
      return true;
    } else {
      return false;
    }
  };

  const alreadyAttended = async () => {
    try {
      const query = {
        exam_id: quizItem._id,
      };
      const res = await examService.checkExamAttendStatus(query);
      if (parseInt(quizItem?.total_questions) > 0) {
        if (res.data.mode == 1) {
          navigate('/grandquiz', {
            state: {
              grandQuiz: { ...quizItem, edraaquiz_count: parseInt(res.data.edraaquiz_count) },
            },
          });
          return true;
        } else if (res.data.mode == 2) {
          // return true;
          navigate('/edraaquizresult', { state: { edraaquizId: quizItem._id } });
        } else {
          navigate('/edraaquizresult', { state: { edraaquizId: quizItem._id } });

          // return false;
        }
      } else {
        toast.error('This Exam is not available for now!', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
          transition: Bounce,
        });
      }
    } catch (err) {
      return false;
    } finally {
      console.log('inside finally');
    }
  };

  return (
    <div
      className='grandtestcontainer'
      onClick={() => {
        alreadyAttended();
      }}
    >
      <div className='grandtestimage'>
        <img
          src={quizItem?.image ? apiConstants.imgUrl + quizItem.image : '/img/exam_dummy.jpeg'}
          className='grandquizimg'
        />
      </div>
      <div className='grandtestdetails' dir='rtl' style={{ display: 'none' }}>
        <div className='mocktexthead' style={{ fontFamily: 'Cairo', textAlign: 'unset' }}>
          {trimString(quizItem?.name, 30)}
        </div>
        <div className='grandquizdate'>{moment(quizItem?.exam_date).format('DD-MMM-YYYY')}</div>
        <div className='grandquiztime'>
          <img src='/img/time.png' className='clockicon' />
          {secondsToHHMM(quizItem?.time_duration)}
        </div>
      </div>
    </div>
  );
};
